import React from 'react';
import PublicPageShell from '../components/PublicPageShell';
import IndustryPageTemplate from '../components/IndustryPageTemplate';
import { useLanguage } from '../contexts/LanguageContext';
import { getLocalizedFiveMSolution } from '../data/industries';

const FiveMCommerceContent = () => {
  const { currentLang } = useLanguage();
  const page = getLocalizedFiveMSolution(currentLang);
  return <IndustryPageTemplate page={page} />;
};

const FiveMCommercePage = () => (
  <PublicPageShell>
    <FiveMCommerceContent />
  </PublicPageShell>
);

export default FiveMCommercePage;
